import React from "react";
import { Databox, LoadGraphic, Step } from "../components-static/Common";
import EmptyPageLayout from "../components-app/EmptyPageLayout";
import { Input, Button, TextButton } from "../components-static/Input";
import { ContractorPurpose } from "../data/Options";
import u from "../utilities/Utilities";
import "../styles/visitor-self-submission.scss";

export default class ContractorSelfSubmission extends React.Component {
  state = {
    loading: false,
    loadText: "Submitting...",
    step: "register",
    token: "none",
    entryData: {
      purpose: "Maintenance",
    },
    fields: [],
    error: "",
  };

  componentDidMount = () => {
    const token = u.getQuery(this.props, "token");
    if (token) {
      this.setState({
        token: token,
        step: "success",
        instantiated: true,
      });
    } else {
      u.post({
        url: "/noauth/get-visitor-selfsubmit-config",
        data: {},
        success: ({ tenantOptions, purposeOptions }) => {
          this.setState({
            fields: [
              {
                dataType: "box",
                field: "name",
                label: "Your Name",
                rules: { required: true },
              },
              {
                dataType: "box",
                field: "companyName",
                label: "Your Company",
                rules: { required: true },
              },
              {
                dataType: "box",
                field: "contactNo",
                label: "Contact No.",
                rules: { required: true, mobileNumber: true },
                info: "Allows building management to contact you in an event of an emergency",
              },
              {
                dataType: "select",
                field: "tenantID",
                label: "Visiting Tenant",
                options: tenantOptions,
                rules: { required: true },
              },
              {
                dataType: "select",
                field: "purpose",
                label: "Purpose",
                options: ContractorPurpose,
                rules: { required: true },
              },
            ],

            instantiated: true,
          });
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  };

  onValidate = (fields) => {
    this.setState({ error: "" });
    const input = fields.map((item) => {
      return item.field;
    });
    const entryData = this.state.entryData;

    for (var i = 0; i < input.length; i++) {
      const current = this.refs[input[i]].validate();
      if (!current.valid) {
        this.setState({ error: current.value });
        return 0;
      }
    }

    this.setState({ loading: true, error: "", loadText: "Submitting..." });

    u.post({
      url: "/noauth/contractor-self-submit",
      data: entryData,
      success: ({ qrcodeToken }) => {
        this.setState({ step: "success", loading: false });
      },
      error: (error, status) => {
        this.setState({ error: error, loading: false });
      },
    });
  };

  onChange = (value, label, index) => {
    let entryData = this.state.entryData;
    entryData[label] = value;
    this.setState({ entryData: entryData });
  };

  onFocus = (field) => {
    if (field.scrollToBottom) {
      const objDiv = document.getElementById("root");
      objDiv.scrollTop = objDiv.scrollHeight;
    }
  };

  render = () => {
    const { entryData, fields, token, step } = this.state;

    if (!this.state.instantiated) {
      return <div className="page-error">{this.state.error}</div>;
    }
    return (
      <EmptyPageLayout
        title="Contractor Self Registration"
        url="/contractor"
        className="self-sub-container"
        style={{ backgroundColor: step == "register" ? "#40928c" : "#ffff33" }}
      >
        <div style={{ position: "relative" }}>
          <LoadGraphic active={this.state.loading} text={this.state.loadText} />

          <div
            className="content-container"
            style={{ textAlign: "center", color: "#000000" }}
          >
            <img
              src="/images/app/vita-dark.png"
              style={{ width: "150px", margin: "20px auto" }}
            />
            <h2 style={{ margin: 0, padding: 0 }}>Contractor Registration</h2>
            <Step active={step == "register"}>
              <div>
                <div
                  style={{
                    margin: "20px auto 40px auto",
                  }}
                >
                  We are committed to protecting your personal data. For full
                  details on how your data is handled, please refer to our{" "}
                  <a href="/privacy-policy" rel="noopener">
                    <b>Privacy Policy</b>
                  </a>
                  .
                  <br />
                  <br />
                  We collect, use, disclose and otherwise process your
                  information to, among other things, manage building access,
                  ensure safety and security and comply with legal obligations.
                  <br />
                  <br />
                  Please note that the asset is monitored by CCTV surveillance
                  24 hours a day.
                  <br />
                  <br />
                  To help us maintain a safe and secure environment, we kindly
                  ask that you complete the <b>contractor registration</b> form
                  below with all required information.
                  <br />
                </div>

                <div>
                  {fields.map((item, index) => {
                    return (
                      <Input
                        key={index}
                        ref={item.field}
                        fields={{
                          ...item,
                          onChange: this.onChange,
                        }}
                        onFocus={this.onFocus}
                        content={entryData}
                        style={{
                          margin: "20px auto",
                          fontSize: "18px",
                        }}
                      />
                    );
                  })}
                </div>

                <div
                  className="segment-buttons"
                  style={{
                    position: "relative",
                    margin: "30px auto",
                    textAlign: "center",
                  }}
                >
                  <div className="page-error">{this.state.error}</div>

                  <TextButton
                    style={{ color: "#facf59" }}
                    onClick={() => {
                      this.onValidate(fields);
                    }}
                  >
                    Register
                  </TextButton>
                </div>

                <div style={{ margin: "20px auto" }}>
                  In the event of an emergency, please follow all instructions
                  provided by our on-site management and security teams to
                  ensure your safety and the safety of others.
                  <br />
                  <br />
                  <br />
                  This asset is managed by Vita Property Services Pte Ltd.
                </div>
              </div>
            </Step>

            <Step active={step == "success"} scrollAnchor={"empty-root"}>
              <div style={{ textAlign: "left", margin: "20px auto 0 auto" }}>
                <div>
                  <b>Thank you for completing your contractor registration.</b>
                  <br />
                  <br />
                  We are committed to protecting your personal data. For full
                  details on how your data is handled, please refer to our{" "}
                  <a href="/privacy-policy" rel="noopener">
                    <b>Privacy Policy</b>
                  </a>
                  <br />
                  <br />
                  The premises are monitored by 24-hour CCTV.
                </div>

                <div style={{ marginTop: "20px" }}>
                  For your safety and the safety of others:
                </div>

                <ul>
                  <li>
                    Always follow instructions from on-site management and
                    security teams.
                  </li>
                  <li>
                    Unless advised otherwise, you must use the designated goods
                    lifts to access the upper floors—passenger lifts are{" "}
                    <b>strictly</b> for tenants and visitors.
                  </li>
                  <li>
                    Wear appropriate PPE and observe all signage and restricted
                    zones
                  </li>
                  <li>
                    Report any hazards or incidents immediately to the concierge
                    or building management.
                  </li>
                </ul>

                <div style={{ marginTop: "20px", paddingBottom: "20px" }}>
                  In the event of an emergency, please follow all instructions
                  provided by our on-site management and security teams.
                  <br />
                  <br />
                  Please show this confirmation of registration to security who
                  willthen provide you with an access pass for the site.
                  <br />
                  <br />
                  You will be required to return your access pass after you have
                  completed your work or service.
                  <br />
                  <br />
                  <b>Passes are valid for one day only. </b>The landlord may
                  charge up to $50 (plus GST) for any cards not returned.
                </div>
              </div>
              <div style={{ margin: "20px auto" }}>
                This asset is managed by Vita Property Services Pte Ltd.
              </div>
            </Step>
          </div>
        </div>
      </EmptyPageLayout>
    );
  };
}
